import React from 'react';

// A small top-down chair glyph. At rotation 0 the thicker bar (backrest) faces up/outward —
// chairLayout.js's per-edge rotation values orient this to face into the table on every side.
const ChairIcon = ({ style }) => (
  <svg viewBox="0 0 14 14" width="14" height="14" className="chairIcon" style={style}>
    <rect x="1" y="4" width="12" height="9" rx="2.5" fill="currentColor" opacity="0.85" />
    <rect x="1" y="1" width="12" height="3.5" rx="1.5" fill="currentColor" />
  </svg>
);

export default ChairIcon;
